/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
import React from 'react';
import { columnCode } from '../../enums/columnCodeEnumsContractor';
import 'jspreadsheet-ce/dist/jspreadsheet.css';
import CommonCreationErrorsApp from "./Functionality/CommonCreationErrorsApp";
import {MODELS} from "../../Apis/Models";
import routes from "../../Routes/routes";
import HeadTittle from "../../components/HeadTittle";
import ButtonAction from "../../components/buttons/ButtonAction";
import DivContainerBody from "../../components/DivContainerBody";
import CreationErrorsBody from "./SubComponents/CreationErrorsBody";
import {permissionObj} from "../../Helpers/permission";
import CreationErrorsSupplierApp from "./Functionality/CreationErrorsSupplierApp";

const CreationErrorsSupplier = () => {
    const props = CommonCreationErrorsApp({
        moduleId: MODELS.Supplier,
        goBack:routes.suppliers.main,
        validateSpaces:null,
        columns:new Array(11).fill({ type: 'text', width: 78 })
    });
    const {t, DEV, permission, navigate, errorsArray, jRef, totalErrors, selectedErrorIndex} = props;
    const {handleConfirm, handleUploadFile} = CreationErrorsSupplierApp(props);

    if(!DEV && (!permission?.includes(permissionObj.WEB_SUPPLIER_READ) || !permission?.includes(permissionObj.WEB_SUPPLIER_IMPORT))) navigate(routes.forbidden);

    return (
       <>
           <HeadTittle name={t('import')} link={routes.suppliers.main}>
               {totalErrors === 0 ? (
                   <ButtonAction
                       id='btn_ces_import'
                       name='import'
                       className='btn-icon-accent-450'
                       onClick={handleConfirm}
                   />
               ) : (
                   <ButtonAction
                       id='btn_ces_verify'
                       name='verify'
                       className='btn-icon-accent-450'
                       onClick={handleUploadFile}
                   />
               )}
           </HeadTittle>
           <DivContainerBody>
               <CreationErrorsBody
                   mainJRef={{name:t('excel'), jRef:jRef}}
                   totalErrors={totalErrors}
                   errorsArray={errorsArray}
                   selectedErrorIndex={selectedErrorIndex}
                   columnCode={columnCode}
               />
           </DivContainerBody>
       </>
    );
};

export default CreationErrorsSupplier;
